import React, {Component} from 'react'
import debounce from 'lodash.debounce'
import {ReactComponent as LupeIcon} from '@shop/icon-fonts/optimized/lupe.svg'
import {PrimaryIcon} from '../Icon/Icon.styled'
import AppContext from '../../context'
import {MiddleBarButton} from '../MiddleBar'
import {AccessibleLabel, AccessibleText} from '../../utils/styled'
import {DEVICE_TYPES} from '../../utils'
import SearchSuggestion from '../SearchSuggestion'
import * as SC from './SearchBar.styled'


const SEARCH_BAR_ID = 'search_query_field'
const DEBOUNCE_TIME = 300
const SUGGESTIONS_ID = 'srh_suggestions'
export const SEARCH_MIDDLE_BAR_BUTTON_ID = 'srh-mbsearch'

class SearchBar extends Component {
  static contextType = AppContext

  constructor(props) {
    super(props)
    this.state = {
      suggestions: [],
      query: '',
      showSuggestions: false
    }
    this.timeOutId = null
    this.searchFlyout = React.createRef()
    this.searchInput = React.createRef()
    this.onClickMiddlebarButton = this.onClickMiddlebarButton.bind(this)
    this.searchFocus = this.searchFocus.bind(this)
    this.handleSearchOnChange = this.handleSearchOnChange.bind(this)
    this.debouncedAutoComplete = debounce(this.apiRequest, DEBOUNCE_TIME)
    this.onBlur = this.onBlur.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.handleKeyUp = this.handleKeyUp.bind(this)
  }

  onBlur() {
    this.timeOutId = setTimeout(() => {
      this.setState({showSuggestions: false})
    })
  }

  onFocus() {
    clearTimeout(this.timeOutId)
  }

  onClickMiddlebarButton() {
    const {isBurgerNavOpen, setBurgerNavOpen, isSearchFlyoutOpen, setSearchFlyoutOpen} = this.context
    if (isBurgerNavOpen) {
      setBurgerNavOpen(false)
    }
    setSearchFlyoutOpen(!isSearchFlyoutOpen, this.searchFocus)
  }

  onSubmitSearch = (event) => {
    event.preventDefault()
    window.location = `/esearch.htm#q=${this.searchInput.current.value}`
  }

  async apiRequest(value) {
    const {exorbyteId, exorbyteProxyUrl} = this.context
    if (exorbyteProxyUrl) {
      const exoUrl = exorbyteProxyUrl.replace('http://', 'https://')
      this.setState({query: value})
      try {
        const response = await fetch(`${exoUrl}?sv=suggest&p=${exorbyteId}&wt=json&q=${value}`)
        if (response.ok) {
          const suggestions = await response.json()
          this.setState({suggestions, showSuggestions: true})
        } else {
          this.setState({showSuggestions: false})
        }
      } catch (e) {
        this.setState({showSuggestions: false})
      }
    }
  }

  handleSearchOnChange(event) {
    event.persist()
    const {target: {value}} = event
    if (value.length > 2) {
      this.debouncedAutoComplete(value)
    } else {
      this.setState({suggestions: []})
    }
  }

  handleKeyUp(e) {
    if (e.key === 'Enter') {
      const {showSuggestions} = this.state
      this.setState({showSuggestions: !showSuggestions})
    } else if (e.key === 'Escape') {
      this.setState({showSuggestions: false}, this.searchFocus)
    }
  }

  searchFocus() {
    const {isSearchFlyoutOpen} = this.context
    if (isSearchFlyoutOpen) {
      this.searchInput.current.focus()
    }
  }

  render() {
    const {suggestions, query, showSuggestions} = this.state
    const {device, translations, showCart, isSearchFlyoutOpen} = this.context

    const isMobile = device === DEVICE_TYPES.SMARTPHONE || device === DEVICE_TYPES.PHABLET
    const search = (
      <SC.SearchBarWrapper
        show={!isMobile || (isMobile && isSearchFlyoutOpen)}
        onFocus={this.onFocus}
        onBlur={this.onBlur}
        onKeyUp={this.handleKeyUp}
      >
        <form name="miniSearchBox" onSubmit={this.onSubmitSearch} autoComplete="off" role="search">
          <AccessibleLabel id={`${SEARCH_BAR_ID}-label`}>
            {translations.get('shop.header.search.label')}
          </AccessibleLabel>
          <SC.SearchBarInput
            id={SEARCH_BAR_ID}
            onChange={this.handleSearchOnChange}
            ref={this.searchInput}
            name="q"
            type="text"
            placeholder={translations.get('shop.header.search.placeholder')}
            aria-labelledby={`${SEARCH_BAR_ID}-label`}
          />
          {showSuggestions && suggestions.length > 0
            && <SearchSuggestion
              id={SUGGESTIONS_ID}
              term={query}
              suggestions={suggestions}
            />}
          <SC.SubmitButton
            type="submit"
            aria-labelledby={`${SEARCH_BAR_ID}-label`}
          >
            <PrimaryIcon>
              <LupeIcon />
            </PrimaryIcon>
          </SC.SubmitButton>
        </form>
      </SC.SearchBarWrapper>
    )

    return (
      <>
        {!isMobile
          && search}

        {isMobile
          && <>
            <MiddleBarButton
              id={SEARCH_MIDDLE_BAR_BUTTON_ID}
              onClick={this.onClickMiddlebarButton}
              aria-haspopup="true"
              aria-expanded={isSearchFlyoutOpen}
            >
              <AccessibleText>
                {translations.get('shop.header.accessible.search.menu')}
              </AccessibleText>
              <PrimaryIcon>
                <LupeIcon />
              </PrimaryIcon>
            </MiddleBarButton>
            <SC.SearchBarFlyout
              ref={this.searchFlyout}
              show={isSearchFlyoutOpen}
              showCart={showCart}
              aria-hidden={!isSearchFlyoutOpen}
            >
              {search}
            </SC.SearchBarFlyout>
          </>}
      </>
    )
  }
}

export default SearchBar
